import {useState} from 'react';
import {Box, Collapse, Table, TableBody, TableCell, TableHead, TableRow, Typography} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import {useTranslation} from 'react-i18next';
import moment from 'moment';
import config from '../../../../app/config';
import EditIcon from '@mui/icons-material/Edit';
import {useStylesECDS} from './ecdsStyle';
import {useDispatch} from 'react-redux';
import {hasPermission, Permissions} from '../../../../store/reducers/user';
import clsx from 'clsx';

const EcdsObsRow = (props) => {
    const {t} = useTranslation();
    const classes = useStylesECDS();
    const dispatch = useDispatch();

    const [open, setOpen] = useState(false);

    const canAmendTime = dispatch(hasPermission(Permissions.AGYLE_IS_ECDS_ADMIN));
    return (
        <>
            <TableRow>
                <TableCell
                    className={clsx(classes.rowCell, "refresh", props.index % 2 && 'odd')}
                    size="small"
                >
                    <IconButton
                        aria-label="expand row"
                        size="small"
                        onClick={() => setOpen(!open)}
                    >
                        {open ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
                    </IconButton>
                </TableCell>

                <TableCell
                    className={clsx(classes.rowCell, "refresh", props.index % 2 && 'odd')}
                    align="left"
                    size="small"
                >
                    {props.index + 1}
                </TableCell>

                <TableCell
                    className={clsx(classes.rowCell, "refresh", props.index % 2 && 'odd')}
                    align="center"
                    size="small"
                >
                    {props.obs?.date}
                </TableCell>

                <TableCell
                    className={clsx(classes.rowCell, "refresh", props.index % 2 && 'odd')}
                    align="center"
                    size="small"
                >
                    {props.obs?.by}
                </TableCell>

                <TableCell
                    className={clsx(classes.rowCell, "refresh", props.index % 2 && 'odd')}
                    align="center"
                    size="small"
                >
                    {props.obs?.status}
                </TableCell>

                <TableCell
                    className={clsx(classes.rowCell, "refresh", props.index % 2 && 'odd')}
                    align="center"
                    size="small"
                >
                    <IconButton disabled={!canAmendTime} onClick={() => props.editObs(props.obs.id)}>
                        <EditIcon/>
                    </IconButton>
                </TableCell>
            </TableRow>

            <TableRow>
                <TableCell style={{paddingBottom: 0, paddingTop: 0}} colSpan={6}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <Box sx={{margin: 1}}>
                            <Typography variant="h6" gutterBottom component="div">
                                {t(props.innerText)}
                            </Typography>

                            <Table size="small" aria-label="purchases">
                                <TableHead>
                                    <TableRow>
                                        {props.innerColumns.map(col => (
                                            <TableCell key={col}>
                                                {t(col)}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {props.innerRow.map((row) => (
                                        <TableRow key={row?.name}>
                                            <TableCell>
                                                {t(row?.name)}
                                            </TableCell>
                                            {props.assessment &&
                                                <TableCell>
                                                    {row?.score}
                                                </TableCell>
                                            }

                                            {(props.observation || props.findings) &&
                                                <TableCell>
                                                    {row?.value}
                                                </TableCell>
                                            }

                                            {props.observation &&
                                                <TableCell>
                                                    {row?.unit}
                                                </TableCell>
                                            }
                                            <TableCell>
                                                {row?.timestamp ? moment(row?.timestamp).format(config.defaultDateTimeFormat) : '-'}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </Box>
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

export default EcdsObsRow;